import {
  AuthService,
  LoginResultDto,
  LoginWithEmailDto,
} from "@generated/ad-channel-admin";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toastApiError, toastSuccess } from "@toast";
import { useNavigate } from "react-router-dom";
import { deleteCookie, setCookie } from "cookies-next";

import { ApiError } from "@generated/ad-channel-admin/core/ApiError";
import { OpenAPI } from "@generated/ad-channel-admin/core/OpenAPI";

export const usePartnerAdminLoginByEmail = () => {
  const navigate = useNavigate();

  return useMutation<LoginResultDto, ApiError, LoginWithEmailDto>({
    mutationFn: (requestBody: LoginWithEmailDto) =>
      AuthService.loginByEmail(requestBody),
    onSuccess: (data, variables) => {
      OpenAPI.TOKEN = data.token;
      setCookie("adminToken", data.token, {
        maxAge: 60 * 60 * 24 * 30,
        expires: new Date(Date.now() + 60 * 60 * 24 * 30 * 1000),
      });
      setCookie("adminRole", "PARTNER_ADMIN", {
        maxAge: 60 * 60 * 24 * 30,
        expires: new Date(Date.now() + 60 * 60 * 24 * 30 * 1000),
      });
      setCookie("adminEmail", variables.email, {
        maxAge: 60 * 60 * 24 * 30,
        expires: new Date(Date.now() + 60 * 60 * 24 * 30 * 1000),
      });
      toastSuccess("로그인에 성공했습니다.");
      navigate("/partner-quiz-packs/list");
    },
    onError: (err: ApiError) => {
      toastApiError(err, "로그인에 실패했습니다.");
    },
  });
};

export const usePartnerAdminLogout = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return () => {
    queryClient.clear();
    deleteCookie("adminToken");
    deleteCookie("adminRole");
    deleteCookie("adminEmail");
    OpenAPI.TOKEN = "";
    toastSuccess("로그아웃 되었습니다.");
    navigate("/partner-login", { replace: true });
  };
};
